import React, { useEffect, useState } from 'react';
import './FontSelector.css';

const FontSelector = (props) => {
	const [activeIndex, setActiveIndex] = useState(0);
	let imageUrl =
		(props.stoleMeta &&
			props.stoleMeta.image &&
			props.stoleMeta.image['fonts-sprite']) ||
		'';
	const spriteStyle = {
		background:
			'url(' +
			process.env.REACT_APP_JOSTENS_CDN_HOST +
			imageUrl +
			') no-repeat',
	};
	window.onclick = function (event) {
		if (
			!event.target.matches('.select-font') &&
			!event.target.matches('.sprite')
		) {
			props.setSelectFont(false);
		}
	};

	useEffect(() => {
		if (props.selectFont) {
			let index =
				(props.options &&
					props.options.findIndex(
						(opt) => opt.consumerFontCode === props.selectedOption
					)) ||
				0;
			document.getElementById(index).focus();
			setActiveIndex(index);
		}
	}, [props.selectedOption, props.selectFont]);
	return (
		<>
			<label className='select_title' htmlFor='selectDropdown'>
				{props.title}
			</label>
			<div
				className={`select-font`}
				id='selectDropdown'
				onClick={() => props.setSelectFont(!props.selectFont)}
				tabIndex='0'
				onKeyDown={(event) => {
					if (event.key === 'Enter' || event.key === ' ') {
						props.setSelectFont(!props.selectFont);
					}
					if (event.key === 'Escape' && props.selectFont) {
						props.setSelectFont(!props.selectFont);
					}
				}}>
				<span
					className={`sprite ${props.selectedOption}`}
					style={spriteStyle}></span>
				<i className='fas fa-angle-down'></i>
			</div>
			<div
				className={`font-options ${props.selectFont ? 'd-block' : 'd-none'}`}>
				{props.options &&
					props.options.map((opt, index) => (
						<span
							style={spriteStyle}
							key={index}
							className={`sprite ${opt.consumerFontCode}`}
							id={index}
							onClick={() => props.OptionSelect(opt)}
							tabIndex='0'
							onKeyDown={(event) => {
								if (event.key === 'Enter' || event.key === ' ') {
									props.OptionSelect(opt);
								}
								if (event.key === 'Escape') {
									props.setSelectFont(!props.selectFont);
								}
								if (event.key === 'ArrowDown') {
									let nextEle =
										activeIndex === props.options.length
											? activeIndex
											: activeIndex + 1;
									setActiveIndex(nextEle);
									document.getElementById(nextEle).focus();
								}
								if (event.key === 'ArrowUp') {
									let nextEle =
										activeIndex === 0 ? activeIndex : activeIndex - 1;
									setActiveIndex(nextEle);
									document.getElementById(nextEle).focus();
								}
							}}></span>
					))}
			</div>
		</>
	);
};

export default React.memo(FontSelector);
